import $ from 'jquery';

const autocompleteSearch = (seachTerm, partnerId) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://clients1.google.com/complete/search',
      dataType: 'jsonp',
      data: {
        'hl': 'no', //  Language
        'ds': 'cse', //  Restrict lookup to Custom Search Engine
        'q': seachTerm, //  query term
        'client': 'partner', //  client type set to partner,
        'partnerid': partnerId, //  custom search engine ID
      },
      success: (data) => {
        const hits = data[1].map((hit) => {
          return { value: hit[0] };
        });
        resolve(hits);
      },
      error: () => {
        reject();
      },
    });
  });
};

export { autocompleteSearch };
